import { ChildPaymentMethod } from 'types';
import { settlementTexts } from 'consts/text';

export const childPaymentFormTypeLabels: Record<ChildPaymentMethod, string> = {
    [ChildPaymentMethod.BANK_TRANSFER]: settlementTexts.children.paymentTypes.transfer,
    [ChildPaymentMethod.CASH]: settlementTexts.children.paymentTypes.cash,
    [ChildPaymentMethod.PAYU]: settlementTexts.children.paymentTypes.payu,
    [ChildPaymentMethod.BLIK]: settlementTexts.children.paymentTypes.blik,
    [ChildPaymentMethod.CARD]: settlementTexts.children.paymentTypes.card,
    [ChildPaymentMethod.OTHER]: settlementTexts.children.paymentTypes.other,
};
